<template>

  <div>
    
    <div class="flex flex-row items-top justify-between">
      <h1 class="text-lg font-semibold mb-3">Dashboard </h1>
    </div>

    <hr class="border-b border-gray-100 mb-3">

    <v-container v-if="fetchingStats">
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            type="article"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>

    <div class="-mx-2" v-if="!fetchingStats && dashboard_stats">
      <div class="flex flex-row flex-wrap mb-2">
        <div class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
          <v-card
            class="pa-2"
            tile
          >
            <div :class="(($vuetify.breakpoint.xs) ? 'p-1' : 'p-3')">
              <div class="dashboard-box-title">Total Searches</div>

              <div class=""><strong class="text-xl">{{ dashboard_stats.total_searches }}</strong></div>
              
              <div class="stats-box-icon-bg blue"></div>
              <div class="stats-box-icon">
                <svg width="40" height="40" viewBox="5 5 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1117_1999)">
                    <path d="M23.9527 23.9711C24.1618 23.7619 24.5009 23.7619 24.71 23.9711L31.0559 30.3169C31.265 30.526 31.265 30.8651 31.0559 31.0742C30.8467 31.2833 30.5077 31.2833 30.2985 31.0742L23.9527 24.7284C23.7436 24.5193 23.7436 24.1802 23.9527 23.9711Z" fill="#3EBB80" stroke="#3A9BDB"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M27.3294 17.6647C27.3294 12.327 23.0024 8.00001 17.6647 8.00001C12.327 8.00001 8 12.327 8 17.6647C8 23.0024 12.327 27.3294 17.6647 27.3294C23.0024 27.3294 27.3294 23.0024 27.3294 17.6647ZM25.2584 17.6647C25.2584 13.4708 21.8586 10.071 17.6647 10.071C13.4708 10.071 10.071 13.4708 10.071 17.6647C10.071 21.8586 13.4708 25.2584 17.6647 25.2584C21.8586 25.2584 25.2584 21.8586 25.2584 17.6647Z" fill="#3A9BDB"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_1117_1999">
                      <rect width="40" height="40" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>

              </div>
            </div>
          </v-card>
        </div>
        <div class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
          <v-card
            class="pa-2"
            tile
          >
            <div :class="(($vuetify.breakpoint.xs) ? 'p-1' : 'p-3')">
              <div class="dashboard-box-title">Total SMS Sent</div>

              <div class=""><strong class="text-xl">{{ dashboard_stats.total_sms_sent }}</strong></div>
              
              <div class="stats-box-icon-bg blue"></div>
              <div class="stats-box-icon">
                <svg width="27" height="25" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.5595 19.328H21.1196V24.3521L14.2076 19.328H3.99957C1.79151 19.328 -0.000431061 17.5361 -0.000431061 15.328V4C-0.000431061 1.79194 1.79151 0 3.99957 0H22.5596C24.7676 0 26.5596 1.79194 26.5596 4V15.328C26.5596 17.5361 24.7676 19.328 22.5596 19.328H22.5595ZM24.6716 4C24.6716 2.848 23.7115 1.88794 22.5595 1.88794H3.99951C2.84751 1.88794 1.88745 2.848 1.88745 4V15.328C1.88745 16.48 2.84751 17.4401 3.99951 17.4401H14.8155L19.1995 20.6401V17.4401H22.5595C23.7115 17.4401 24.6716 16.48 24.6716 15.328V4Z" fill="#3A9BDB"/>
                </svg>
              </div>
            </div>
          </v-card>
        </div>
        <div class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
          <v-card
            class="pa-2"
            tile
          >
            <div :class="(($vuetify.breakpoint.xs) ? 'p-1' : 'p-3')">
              <div class="dashboard-box-title">Total Responses</div>

              <div class=""><strong class="text-xl">{{ dashboard_stats.total_responses }}</strong></div>
              
              <div class="stats-box-icon-bg blue"></div>
              <div class="stats-box-icon">
                <svg width="32" height="25" viewBox="0 0 32 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M31.3848 2.70435e-05C31.5367 -0.000736203 31.6827 0.0593099 31.7901 0.166934C31.8975 0.274302 31.9575 0.420092 31.957 0.571993V12.4571C31.9575 12.609 31.8975 12.755 31.7901 12.8624C31.6828 12.9698 31.5367 13.0298 31.3848 13.0293H28.2123V16.6771C28.2105 16.9063 28.0713 17.1124 27.8591 17.1994C27.6472 17.2867 27.4032 17.2384 27.2406 17.0766L23.1898 13.0293H20.2323V19.6847C20.2329 19.8366 20.1728 19.9824 20.0654 20.0901C19.9581 20.1974 19.812 20.2575 19.6601 20.257H8.76702L4.71624 24.3042H4.7165C4.55315 24.4666 4.30839 24.5146 4.09594 24.4264C3.88324 24.3378 3.74483 24.1304 3.74483 23.9002V20.257H0.572321C0.420425 20.2575 0.27438 20.1974 0.167006 20.09C0.059639 19.9824 -0.000408173 19.8366 9.91821e-05 19.6847V7.79964C-0.00041008 7.64774 0.0596352 7.50195 0.167006 7.39458C0.274374 7.28696 0.42042 7.22691 0.572321 7.22742H11.7247V0.571973C11.7241 0.420079 11.7842 0.274289 11.8916 0.166914C11.9989 0.0592926 12.145 -0.000754908 12.2969 7.16607e-06L31.3848 2.70435e-05ZM30.8172 1.13988H12.8654V11.8851L19.6603 11.8849C19.6842 11.8849 19.7079 11.8864 19.7315 11.8894H23.4251C23.576 11.8884 23.7213 11.9472 23.8291 12.053L27.0726 15.2968V12.4571C27.0739 12.1423 27.3301 11.8882 27.6449 11.8894H30.8174L30.8172 1.13988ZM26.2644 4.00834C26.5796 4.00834 26.8348 4.26379 26.8348 4.57877C26.8348 4.89376 26.5796 5.14921 26.2644 5.14921H17.4217C17.1068 5.14921 16.8513 4.89376 16.8513 4.57877C16.8513 4.26379 17.1068 4.00834 17.4217 4.00834H26.2644ZM26.2644 8.02681C26.4178 8.02325 26.5662 8.08177 26.6758 8.18914C26.7855 8.29626 26.8473 8.44332 26.8473 8.59674C26.8473 8.75016 26.7855 8.89697 26.6758 9.00409C26.5662 9.11145 26.4178 9.16998 26.2644 9.16667H17.4217C17.2683 9.16998 17.1202 9.11146 17.0106 9.00409C16.9009 8.89697 16.8391 8.75016 16.8391 8.59674C16.8391 8.44332 16.9009 8.29626 17.0106 8.18914C17.1202 8.08177 17.2683 8.02325 17.4217 8.02681H26.2644ZM11.7244 8.3675H1.1394V19.1173H4.31191C4.62664 19.116 4.88285 19.3702 4.88413 19.6849V22.5247L8.1279 19.2809H8.12764C8.23552 19.1751 8.3808 19.116 8.53168 19.1173H19.0913V13.0295H12.2965C12.1446 13.03 11.9985 12.97 11.8911 12.8626C11.7838 12.7552 11.7237 12.6092 11.7242 12.4573L11.7244 8.3675Z" fill="#3A9BDB"/>
                </svg>
              </div>
            </div>
          </v-card>
        </div>

        <div class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
          <v-card
            class="pa-2"
            tile
          >
            <div :class="(($vuetify.breakpoint.xs) ? 'p-1' : 'p-3')">
              <div class="dashboard-box-title">Mobile Numbers</div>

              <div class=""><strong class="text-xl">{{ dashboard_stats.mobile_numbers.sent }}</strong> <span class="text-sm pl-2" style="color:#19233A; opacity: 0.5;">SMS Sent</span> &nbsp;&nbsp;&nbsp; <strong class="text-xl">{{ dashboard_stats.mobile_numbers.responses }}</strong> <span class="text-sm pl-2" style="color:#19233A; opacity: 0.5;">Response<span v-if="dashboard_stats.mobile_numbers.responses != 1">s</span></span></div>
              
              <div class="stats-box-icon-bg"></div>
              <div class="stats-box-icon">
                <svg width="28" height="28" viewBox="0 0 20 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.6245 0H2.50004C1.12499 0 0 1.12499 0 2.50004V27.5C0 28.875 1.12499 30 2.50004 30H16.6251C18.0001 30 19.1251 28.875 19.1251 27.5L19.1249 2.50004C19.1249 1.12499 17.9999 0 16.6249 0L16.6245 0ZM17.8747 27.4995C17.8747 28.1869 17.3122 28.7494 16.6248 28.7494L2.49972 28.7497C1.8123 28.7497 1.24981 28.1872 1.24981 27.4997V24.4372H17.8744L17.8747 27.4995ZM17.8747 23.1871H1.24949V5.12512H17.8741L17.8747 23.1871ZM17.8747 3.87478H1.24949V2.49994C1.24949 1.81252 1.81198 1.25002 2.4994 1.25002H16.6244C17.3118 1.25002 17.8743 1.81252 17.8743 2.49994L17.8747 3.87478Z" fill="#3EBB80"/>
                </svg>
              </div>
            </div>
          </v-card>
        </div>
        <div class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
          <v-card
            class="pa-2"
            tile
          >
            <div :class="(($vuetify.breakpoint.xs) ? 'p-1' : 'p-3')">
              <div class="dashboard-box-title">Voip Numbers</div>

              <div class=""><strong class="text-xl">{{ dashboard_stats.voip_numbers.sent }}</strong> <span class="text-sm pl-2" style="color:#19233A; opacity: 0.5;">SMS Sent</span> &nbsp;&nbsp;&nbsp; <strong class="text-xl">{{ dashboard_stats.voip_numbers.responses }}</strong> <span class="text-sm pl-2" style="color:#19233A; opacity: 0.5;">Response<span v-if="dashboard_stats.voip_numbers.responses != 1">s</span></span></div>
              
              <div class="stats-box-icon-bg orange"></div>
              <div class="stats-box-icon">
                <svg width="36" height="36" viewBox="5 5 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6373 20.9102H9.25599V22.2915H10.6373V20.9102ZM9.25599 20.121C8.82023 20.121 8.4668 20.4741 8.4668 20.9102V22.2915C8.4668 22.7273 8.82025 23.0807 9.25599 23.0807H10.6373C11.0731 23.0807 11.4265 22.7273 11.4265 22.2915V20.9102C11.4265 20.4741 11.0731 20.121 10.6373 20.121H9.25599Z" fill="#FFB443"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4293 20.9102H13.048V22.2916H14.4293V20.9102ZM13.048 20.121C12.6122 20.121 12.2588 20.4742 12.2588 20.9102V22.2916C12.2588 22.7273 12.6122 23.0808 13.048 23.0808H14.4293C14.8651 23.0808 15.2185 22.7273 15.2185 22.2916V20.9102C15.2185 20.4742 14.8651 20.121 14.4293 20.121H13.048Z" fill="#FFB443"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2213 20.9102H16.84V22.2915H18.2213V20.9102ZM16.84 20.121C16.4042 20.121 16.0508 20.4741 16.0508 20.9102V22.2915C16.0508 22.7273 16.4042 23.0807 16.84 23.0807H18.2213C18.6571 23.0807 19.0105 22.7273 19.0105 22.2915V20.9102C19.0105 20.4741 18.6571 20.121 18.2213 20.121H16.84Z" fill="#FFB443"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M32.835 18.4437H6.78919V24.758H32.835V18.4437ZM6.78919 17.6545C6.35344 17.6545 6 18.0077 6 18.4437V24.758C6 25.1938 6.35345 25.5472 6.78919 25.5472H32.835C33.2707 25.5472 33.6242 25.1938 33.6242 24.758V18.4437C33.6242 18.0077 33.2707 17.6545 32.835 17.6545H6.78919Z" fill="#FFB443"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M24.0548 20.9102V22.2916H30.8624V20.9102H24.0548ZM23.6604 20.121C23.4423 20.121 23.2656 20.2978 23.2656 20.5155V22.6861C23.2656 22.9041 23.4423 23.0808 23.6604 23.0808H31.2571C31.4751 23.0808 31.6518 22.9041 31.6518 22.6861V20.5155C31.6518 20.2978 31.4751 20.121 31.2571 20.121H23.6604Z" fill="#FFB443"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.573 9.6943L10.5702 9.69568C9.0452 10.3654 7.97279 11.9262 7.97279 13.7086V14.4978C7.97279 14.9338 8.32624 15.287 8.76198 15.287H12.6601C12.6868 15.287 12.7083 15.2655 12.7083 15.2388C12.7083 13.9139 13.563 12.7916 14.7318 12.3146C16.2277 11.6927 17.9658 11.3407 19.8117 11.3407C21.6831 11.3407 23.4431 11.7027 24.953 12.3402L24.9566 12.3419L24.9599 12.3433C26.0825 12.8297 26.9152 13.9008 26.9152 15.2106C26.9152 15.2527 26.9496 15.2871 26.9917 15.2871H30.8615C31.2973 15.2871 31.6507 14.9339 31.6507 14.4979V13.647C31.6507 11.9128 30.6328 10.4343 29.1493 9.73925C26.4414 8.50574 23.2444 7.7892 19.812 7.7892C16.4225 7.7892 13.2624 8.48784 10.5762 9.69302L10.573 9.6943ZM29.4801 9.02263C31.2287 9.84023 32.4399 11.5893 32.4399 13.647V14.4978C32.4399 15.3696 31.7333 16.0762 30.8615 16.0762H26.9917C26.5135 16.0762 26.126 15.6886 26.126 15.2105C26.126 14.2569 25.5201 13.4463 24.6461 13.0675C23.2383 12.4726 21.5831 12.1299 19.8117 12.1299C18.0634 12.1299 16.428 12.4638 15.0321 13.0444C14.1287 13.4121 13.4975 14.2658 13.4975 15.2389C13.4975 15.7013 13.1226 16.0763 12.6601 16.0763H8.76199C7.8902 16.0763 7.18359 15.3697 7.18359 14.4979V13.7087C7.18359 11.6083 8.44572 9.76673 10.2529 8.97316C13.0445 7.72042 16.315 7 19.8115 7C23.354 7 26.6647 7.73937 29.48 9.02271L29.4801 9.02263Z" fill="#FFB443"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M20.2072 26.731C20.425 26.731 20.6017 26.9074 20.6017 27.1254V28.7041C20.6017 28.9218 20.425 29.0986 20.2072 29.0986C19.9892 29.0986 19.8125 28.9218 19.8125 28.7041V27.1254C19.8125 26.9074 19.9892 26.731 20.2072 26.731Z" fill="#FFB443"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M22.5745 31.0722H17.839V32.6508H22.5745V31.0722ZM17.839 30.283C17.403 30.283 17.0498 30.6364 17.0498 31.0722V32.6508C17.0498 33.0866 17.403 33.44 17.839 33.44H22.5745C23.0106 33.44 23.3637 33.0866 23.3637 32.6508V31.0722C23.3637 30.6364 23.0105 30.283 22.5745 30.283H17.839Z" fill="#FFB443"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M30.8611 31.8615C30.8611 32.0795 30.6844 32.2563 30.4663 32.2563H24.9416C24.7236 32.2563 24.5469 32.0795 24.5469 31.8615C24.5469 31.6438 24.7236 31.467 24.9416 31.467H30.4663C30.6844 31.467 30.8611 31.6438 30.8611 31.8615Z" fill="#FFB443"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.866 31.8615C15.866 32.0795 15.6892 32.2563 15.4712 32.2563H9.9465C9.72848 32.2563 9.55176 32.0795 9.55176 31.8615C9.55176 31.6438 9.72848 31.467 9.9465 31.467H15.4712C15.6892 31.467 15.866 31.6438 15.866 31.8615Z" fill="#FFB443"/>
                </svg>
              </div>
            </div>
          </v-card>
        </div>
        <div class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
          <v-card
            class="pa-2"
            tile
          >
            <div :class="(($vuetify.breakpoint.xs) ? 'p-1' : 'p-3')">
              <div class="dashboard-box-title">Landline Numbers</div>

              <div class=""><strong class="text-xl">{{ dashboard_stats.landline_numbers.sent }}</strong> <span class="text-sm pl-2" style="color:#19233A; opacity: 0.5;">SMS Sent</span> &nbsp;&nbsp;&nbsp; <strong class="text-xl">{{ dashboard_stats.landline_numbers.responses }}</strong> <span class="text-sm pl-2" style="color:#19233A; opacity: 0.5;">Response<span v-if="dashboard_stats.landline_numbers.responses != 1">s</span></span></div>
              
              <div class="stats-box-icon-bg red"></div>
              <div class="stats-box-icon">
                <svg width="36" height="36" viewBox="5 5 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M33.4845 21.0717C33.4605 21.075 33.4365 21.0764 33.4131 21.0764C33.1423 21.0764 32.9073 20.8756 32.8712 20.5998C31.954 13.5628 26.3984 8.00666 19.3614 7.09001C19.0616 7.05089 18.8503 6.7763 18.8895 6.47648C18.9286 6.17668 19.203 5.96539 19.5028 6.00471C27.0321 6.98618 32.9754 12.9296 33.9565 20.4585C33.9956 20.7583 33.7843 21.0327 33.4845 21.0718L33.4845 21.0717ZM26.0486 13.9125C24.2601 12.124 22.0058 10.9413 19.5298 10.4927C19.2327 10.4389 18.9478 10.636 18.894 10.9334C18.8401 11.2308 19.0373 11.5155 19.3347 11.5693C23.921 12.4005 27.5608 16.0403 28.3918 20.6269C28.4398 20.8914 28.6702 21.0767 28.9297 21.0767C28.9621 21.0767 28.995 21.0739 29.0279 21.0678C29.3252 21.014 29.5226 20.7291 29.4686 20.4319C29.0198 17.9555 27.8374 15.7015 26.0486 13.9127L26.0486 13.9125ZM23.8548 20.6862C23.926 20.9235 24.1433 21.0763 24.3788 21.0763C24.4308 21.0763 24.4836 21.0688 24.536 21.0531C24.8256 20.9664 24.9899 20.6614 24.9032 20.3719C24.5292 19.1229 23.8415 17.9729 22.9149 17.046C21.9883 16.1194 20.8383 15.4317 19.5893 15.0577C19.2999 14.971 18.9947 15.1356 18.908 15.4249C18.8213 15.7144 18.9858 16.0195 19.2752 16.1061C21.482 16.7674 23.1939 18.4793 23.8548 20.6862L23.8548 20.6862ZM27.4901 27.7949C28.5182 28.8229 28.5182 30.4957 27.4901 31.5237C27.3381 31.6757 27.2036 31.8136 27.08 31.9402C26.4173 32.6193 26.0175 33.029 24.9343 33.5808C24.3716 33.8675 23.7258 34.01 23.0099 34.01C21.8399 34.01 20.4817 33.6294 18.9877 32.8743C16.9411 31.8398 14.6441 30.1001 12.5195 27.9761C10.3131 25.7697 8.46081 23.332 7.304 21.1121C5.97295 18.5568 5.65341 16.4526 6.37982 15.0264C6.93161 13.9433 7.34153 13.5433 8.02034 12.8808C8.14716 12.757 8.28486 12.6227 8.43688 12.4707C9.46491 11.4427 11.1377 11.4427 12.1657 12.4707L14.5034 14.8084C15.5315 15.8365 15.5315 17.5093 14.5034 18.5373L13.9448 19.0959C13.6514 19.3893 13.6514 19.8667 13.9448 20.1603L19.8008 26.0163C19.9421 26.1576 20.1312 26.2357 20.3329 26.2357C20.5347 26.2357 20.7234 26.1576 20.865 26.0163L21.4236 25.4576C21.9198 24.9615 22.5821 24.6879 23.2882 24.6879C23.994 24.6879 24.6561 24.9613 25.1527 25.4576L27.4901 27.7949ZM26.7166 28.5686L24.3788 26.2309C24.0893 25.9414 23.702 25.7817 23.2883 25.7817C22.8748 25.7817 22.4873 25.9412 22.1976 26.2309L21.6389 26.7896C21.2909 27.1378 20.827 27.3295 20.333 27.3295C19.8391 27.3295 19.3752 27.138 19.0272 26.7896L13.1711 20.9336C12.4512 20.2136 12.4512 19.0418 13.1711 18.3218L13.7298 17.7632C14.3312 17.1618 14.3312 16.1833 13.7298 15.5819L11.3921 13.2442C11.0915 12.9436 10.6963 12.793 10.3016 12.793C9.9064 12.793 9.51162 12.9432 9.21082 13.2442C9.05537 13.3996 8.91424 13.5373 8.78481 13.6639C8.14568 14.2877 7.82511 14.6006 7.35497 15.5232C6.80374 16.6049 7.13077 18.4101 8.27492 20.6065C9.3814 22.7301 11.1635 25.0724 13.2935 27.2021C15.3378 29.2465 17.5355 30.9143 19.4814 31.8975C20.5005 32.4127 21.8084 32.9201 23.0031 32.9201C23.5122 32.9201 24.0003 32.8282 24.4374 32.6054C25.36 32.1354 25.6731 31.8147 26.2967 31.1755C26.4233 31.0461 26.5606 30.905 26.716 30.7495C27.3179 30.1481 27.3179 29.1697 26.7164 28.5682L26.7166 28.5686Z" fill="#e65045"/>
                </svg>
              </div>
            </div>
          </v-card>
        </div>

      </div>
    </div>

    <div v-if="!fetchingSearches">

      <div class="text-gray-600 text-md text-bold mb-4">Add New Search</div>

      <div class="dashboard-box mb-6">
        <v-card
          class=""
          tile
        >
          <div class="lf-search-form dashboard">
            <div class="flex flex-row flex-wrap">
              <div class="w-full lg:w-1/2">
                <v-text-field
                  label="Search"
                  prepend-inner-icon="mdi-magnify"
                  v-model="search_keyword"
                  outlined
                  dense
                  hide-details
                  style="margin-top: 5px;"
                ></v-text-field>

                <hr v-if="$vuetify.breakpoint.xs" class="mt-2 mb-2 ml-3 mr-3" />
              </div>

              <div class="w-full lg:w-1/2 -ml-6">
                <div class="lf-search-location-box">
                  <v-combobox
                      label="Location"
                      prepend-inner-icon="mdi-map-marker-outline"
                      v-model="autocompleteLocationModel"
                      :items="locationFoundItems"
                      :search-input.sync="locationSearchText"
                      item-text="value"
                      item-value="id"
                      hide-no-data
                      return-object
                      outlined
                      dense
                      hide-details
                      @change="selectPlace()"
                      style="height: 40px; border: 0px; margin-top: 5px; margin-bottom: 5px;"
                    >
                  </v-combobox>

                  <hr v-if="$vuetify.breakpoint.xs" class="mt-2 mb-4 ml-3 -mr-3" />
                </div>
              </div>

              <div class="lf-search-form-search-type">
                <v-radio-group
                  class="mt-3"
                  row
                  v-model="search_type"
                  >
                      <v-radio
                      label="Local"
                      :value="'local'"
                      on-icon="mdi-circle"
                      off-icon="mdi-circle-outline"
                      :ripple="false"
                      ></v-radio>
                      <v-tooltip bottom color="#434C5E">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <v-radio
                              label="Multi-Snipe"
                              :value="'in_depth'"
                              on-icon="mdi-circle"
                              off-icon="mdi-circle-outline"
                              :ripple="false"

                            ></v-radio>
                          </span>
                        </template>
                        <span>
                          <strong>Multi-Snipe:</strong>
                          <br />
                          Multi-Snipe search will look up all the zip codes of the city you selected, and then does a search for every keyword in zip code combination.
                          <br /><br />
                          <strong>WARNING:</strong>
                          <br />
                          This can use a lot of Google API credits. If we find 10 zip codes -  we do 10 searches vs. 1. Thats 10 times the API requests.
                          <br />
                          Example: If a Local Search brings in 60 results thats 3 api queries to get the data, and then another 60 to pull the phone number for every listing. 
                          <br />
                          Thats 120 credits. Now if we used the Multi-Snipe feature - ad there were 10 zip codes - we would repeat the process 10 times. That means we'd use 10x the API requests.
                          <br /><br />
                          <strong>Cost breakdown:</strong>
                          <br />
                          - Get Keyword & Location: $0.032
                          <br />
                          - Main Search: $0.032
                          <br />
                          - Business Detail: $0.18 for 60 results
                        </span>
                      </v-tooltip>
                  </v-radio-group>
              </div>

              <div class="lf-search-form-submit-button" @click="addSearch()">
                <i v-if="savingSearch" class="fa fa-spin fa-spinner"></i>
                <i v-else class="mdi mdi-magnify"></i>
              </div>
            </div>
          </div>
        </v-card>
      </div>

      <div v-if="add_search_error" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
          <div v-html="add_search_error"></div>
      </div>

      <div class="flex flex-row flex-wrap">
        <div :class="'w-full lg:w-2/3' + (($vuetify.breakpoint.xs) ? '' : ' pr-5')">
          <div class="text-gray-600 text-md text-bold mb-4">New Searches</div>

          <div v-if="new_searches === null">
            <v-skeleton-loader
              type="article"
              class="mb-4"
            ></v-skeleton-loader>

            <v-skeleton-loader
              type="article"
              class="mb-4"
            ></v-skeleton-loader>

            <v-skeleton-loader
              type="article"
            ></v-skeleton-loader>
          </div>

          <div v-else v-for="search in new_searches" :key="search.id" class="dashboard-box mb-4">
            <v-card
              class="pa-2"
              tile
            >
              <div class="p-2" style="position: relative;">

                <div style="position: absolute; top: -5px; right: -3px;">
                  <v-tooltip v-if="dateDifference(search.created_at) > 20" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <i class="fa fa-clock text-red-600" v-bind="attrs" v-on="on"></i>
                    </template>
                    <span>Your search is taking longer than expected. <br />Please contact us via chat.</span>
                  </v-tooltip>

                  <v-tooltip v-if="dateDifference(search.created_at) < 10" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <i class="fa fa-clock text-green-600" v-bind="attrs" v-on="on"></i>
                    </template>
                    <span>Your job is processing and should be completed between 5 to 10 minutes.</span>
                  </v-tooltip>

                  <v-tooltip v-if="dateDifference(search.created_at) > 10 && dateDifference(search.created_at) < 20" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <i class="fa fa-clock text-orange-600" v-bind="attrs" v-on="on"></i>
                    </template>
                    <span>This is a larger job and will little longer, but it should be completed in less than 20 minutes.</span>
                  </v-tooltip>
                </div>

                <div style="word-break: break-word;">

                  <div class="float-right">
                    <span style="font-size: 12px; color: #757B89;">
                      {{ formatDate(search.created_at) }}
                    </span>
                    <div class="pt-4 text-right">
                      <router-link :to="'/search/' + search.id">
                        <span style="color: #3A9BDB; font-size: 12px; opacity: 0.5; font-weight: bold;">View Results</span>
                      </router-link>
                    </div>
                  </div>

                  <strong>
                    <span class="text-lg">{{ search.keyword }}</span>  

                    <v-chip
                      class="ml-3 -mt-2"
                      small
                      color="orange lighten-5"
                      text-color="orange lighten-1"
                      v-if="search.status == 'pending'"
                    >
                      pending
                    </v-chip>

                    <v-chip
                      class="ml-3 -mt-2"
                      small
                      color="green lighten-5"
                      text-color="green lighten-1"
                      v-if="search.status == 'completed'"
                    >
                      completed
                    </v-chip>

                    <v-chip
                      class="ml-3 -mt-2"
                      small
                      color="blue lighten-5"
                      text-color="blue lighten-1"
                    >
                    {{ search.search_results_count }} leads
                    </v-chip>
                  </strong>

                  <div class="text-gray-600 pt-3" style="font-size: 12px;">
                    <i class="mdi mdi-map-marker-outline mr-1" style="font-size: 16px;"></i> {{ search.location }}
                  </div>
                </div>
                <div style="clear: both;"></div>
                <v-progress-linear
                  class="mt-3"
                  color="blue lighten-2"
                  buffer-value="0"
                  stream
                  :value="search.percentage_completed"
                  v-if="search.status == 'pending'"
                ></v-progress-linear>
              </div>
            </v-card>
          </div>

          <div v-if="new_searches !== null && new_searches.length == 0">
            <div class="dashboard-box">
              <v-card
                class="pa-2"
                tile
              >
                <div class="p-3">

                  <br /><br /><br /><br /><br /><br /><br />

                  <div class="dashboard-box-iconsquare">
                    <div class="dashboard-box-icon-background blue"></div>
                    <div class="dashboard-box-icon">
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1117_1999)">
                          <path d="M23.9527 23.9711C24.1618 23.7619 24.5009 23.7619 24.71 23.9711L31.0559 30.3169C31.265 30.526 31.265 30.8651 31.0559 31.0742C30.8467 31.2833 30.5077 31.2833 30.2985 31.0742L23.9527 24.7284C23.7436 24.5193 23.7436 24.1802 23.9527 23.9711Z" fill="#3EBB80" stroke="#3A9BDB"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M27.3294 17.6647C27.3294 12.327 23.0024 8.00001 17.6647 8.00001C12.327 8.00001 8 12.327 8 17.6647C8 23.0024 12.327 27.3294 17.6647 27.3294C23.0024 27.3294 27.3294 23.0024 27.3294 17.6647ZM25.2584 17.6647C25.2584 13.4708 21.8586 10.071 17.6647 10.071C13.4708 10.071 10.071 13.4708 10.071 17.6647C10.071 21.8586 13.4708 25.2584 17.6647 25.2584C21.8586 25.2584 25.2584 21.8586 25.2584 17.6647Z" fill="#3A9BDB"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_1117_1999">
                            <rect width="40" height="40" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>

                  <div style="text-align: center;">
                    <div class="pt-2 pb-2">
                      <strong>No New Searches</strong>
                    </div>

                    <div class="text-sm mb-4 text-gray-600">
                      Create another search above.
                    </div>
                  </div>
                  
                  <br /><br /><br /><br /><br /><br /><br /><br />
                </div>
              </v-card>
            </div>
          </div>
        </div>
        <div :class="'w-full lg:w-1/3' + (($vuetify.breakpoint.xs) ? '' : ' pl-5')">
          <div class="text-gray-600 text-md text-bold mb-4">Recent Searches ({{ ((recent_searches) ? recent_searches.length : 0) }})</div>

          <div v-if="recent_searches === null">
            <v-skeleton-loader
              type="article"
              class="mb-4"
            ></v-skeleton-loader>

            <v-skeleton-loader
              type="article"
              class="mb-4"
            ></v-skeleton-loader>

            <v-skeleton-loader
              type="article"
            ></v-skeleton-loader>
          </div>

          <div v-else v-for="search in recent_searches" :key="search.id" class="dashboard-box mb-4">
            <v-card
              class="pa-2"
              tile
            >
              <div class="p-2">
                <div style="word-break: break-word;">

                  <div class="float-right">
                    <span style="font-size: 12px; color: #757B89;">
                      {{ formatDate(search.created_at) }}
                    </span>
                    <div class="pt-4 text-right">
                      <router-link :to="'/search/' + search.id">
                        <span style="color: #3A9BDB; opacity: 0.7; font-size: 12px; font-weight: bold;">View Results</span>
                      </router-link>
                    </div>
                  </div>

                  <strong>
                    <span class="text-lg">{{ search.keyword }}</span>  

                    <v-chip
                      class="ml-3 -mt-2"
                      small
                      color="orange lighten-5"
                      text-color="orange lighten-1"
                      v-if="search.status == 'pending'"
                    >
                      pending
                    </v-chip>

                    <v-chip
                      class="ml-3 -mt-2"
                      small
                      color="green lighten-5"
                      text-color="green lighten-1"
                      v-if="search.status == 'completed'"
                    >
                      completed
                    </v-chip>

                    <v-chip
                      class=""
                      small
                      color="red lighten-5"
                      text-color="red lighten-1"
                      v-if="search.status == 'failed'"
                    >
                      failed
                    </v-chip>
                    <v-chip
                      class="ml-3 -mt-2"
                      small
                      color="blue lighten-5"
                      text-color="blue lighten-1"
                    >
                    {{ search.search_results_count }} leads
                    </v-chip>
                  </strong>

                  <span v-if="search.search_results_count == 0" style="padding-left: 10px;">
                    <v-tooltip bottom color="#434C5E">
                      <template v-slot:activator="{ on, attrs }">
                        <i class="fa fa-exclamation-circle text-red-600" v-bind="attrs" v-on="on"></i>
                      </template>
                      <span>Your search did not produce any results. <br />Please check your Google Maps and ValueSerp Settings.</span>
                      <br /><br />
                      <strong>Google</strong><br />
                      For Google please make sure your billing is enabled and the following<br /> API's are enabled: Places API, Geocoding API.
                      <br /><br />
                      <strong>ValueSerp</strong><br />
                      If you're using ValueSerp, please go into settings and hit Save one<br />
                      more time, make sure your API is still valid. If it's not, either remove<br />
                      the key and hit Save, or check your ValueSerp account and make sure it is<br />
                      active and your key is correct.
                    </v-tooltip>
                  </span>

                  <div class="text-gray-600 pt-3" style="font-size: 12px;">
                    <i class="mdi mdi-map-marker-outline mr-1" style="font-size: 16px;"></i> {{ search.location }}
                  </div>
                  <div class="mobile-only mt-1" style="font-size: 12px; color: #757B89;">
                    <i class="fa fa-calendar"></i> {{ formatDate(search.created_at) }}
                  </div>
                </div>
                <div style="clear: both;"></div>
                <v-progress-linear
                  class="mt-3"
                  color="blue lighten-2"
                  buffer-value="0"
                  stream
                  :value="search.percentage_completed"
                  v-if="search.status == 'pending'"
                ></v-progress-linear>
              </div>
            </v-card>
          </div>

          <div v-if="recent_searches !== null && recent_searches.length == 0">
            <div class="dashboard-box">
              <v-card
                class="pa-2"
                tile
              >
                <div class="p-4 text-center text-gray-600 text-sm">
                  No searches found.
                </div>
              </v-card>
            </div>
          </div>
        </div>
      </div>

      <br clear="all" />

    </div>

  </div>

</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import $ from 'jquery'
import ReviewsTable from '@/components/ReviewsTable.vue'
import moment from 'moment'
import { GetSuggestions } from '@/utils/PlaceUtils'

export default {
  components: {
    ReviewsTable
  },
  data () {
    return {
      fetchingStats: false,
      dashboard_stats: null,

      search_keyword: null,
      add_search_error: null,
      
      autocompleteLocationModel: null,
      locationSearchText: null,
      locationEntries: [],

      search_type: 'local',

      savingSearch: false,

      search_location: null,

      searches_interval: null,

      new_searches: null,

      new_searches: null,
      recent_searches: null
    }
  },
  computed: {
    ...mapState({
      searches: state => state.searches.searches,
      fetchingSearches: state => state.searches.fetchingSearches,
    }),
    locationFoundItems () {
      return this.locationEntries
    }
  },
  methods: {
    formatDate: function(date) {
      return moment(String(date)).fromNow()
    },

    dateDifference: function(date) {
      let end = moment();
      var duration = end.diff(moment(date))/1000/60;

      return duration;
    },

    async getSearches() {
      let url = `${process.env.VUE_APP_API_ENDPOINT}/dashboard-searches`;

      let response = await axios.get(url, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.new_searches = response.data.new_searches;
      this.recent_searches = response.data.recent_searches;
    },

    addSearch: async function() {
      this.add_search_error = null

      if (!this.search_keyword) {
        this.add_search_error = "Please enter keyword.";
        return;
      }

      if (!this.search_location) {
        this.add_search_error = "Please enter location.";
        return;
      }

      this.savingSearch = true;

      let response = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/searches/add-search', {
        search_keyword: this.search_keyword,
        search_location: this.search_location,
        search_type: this.search_type
      } , {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        },
      })

      this.$store.dispatch('searches/fetch', {
        page: 1,
        itemsPerPage: 10
      })

      this.getSearches()

      this.savingSearch = false
      this.search_keyword = null
      this.search_location = null
      this.autocompleteLocationModel = null
    },
    getAddressObject(address_components) {

      var ShouldBeComponent = {
        street_number: ["street_number"],
        zip: ["postal_code"],
        address: ["street_address", "route"],
        state: [
          "administrative_area_level_1",
          "administrative_area_level_2",
          "administrative_area_level_3",
          "administrative_area_level_4",
          "administrative_area_level_5"
        ],
        city: [
          "locality",
          "colloquial_area",
          "political",
          "sublocality",
          "sublocality_level_1",
          "sublocality_level_2",
          "sublocality_level_3",
          "sublocality_level_4"
        ],
        country: ["country"]
      };

      var address = {
        street_number: "",
        zip: "",
        address: "",
        state: "",
        city: "",
        country: ""
      };
      address_components.forEach(component => {
        for (var shouldBe in ShouldBeComponent) {
          if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
            if (shouldBe === "country") {
              address[shouldBe] = component.short_name;
            } else {
              address[shouldBe] = component.long_name;
            }
          }
        }
      });
      return address;
    },
    filterPlaces (item, queryText, itemText) {
      return true
    },
    selectPlace() {
      let that = this

      $.get("https://maps.googleapis.com/maps/api/geocode/json?place_id=" + this.autocompleteLocationModel.id + "&fields=name,rating,formatted_phone_number&key=AIzaSyAtBA0jGEnrTzfQlETQOECnG5FdXFBvycU", function(response) {
        that.company_name = that.autocompleteLocationModel.value.split(",")[0];

        let address = that.getAddressObject(response.results[0].address_components);
        let search_location = {};
        search_location.street_number = address.street_number;
        search_location.address = address.address;
        search_location.city = address.city;
        search_location.state = address.state;
        search_location.zip = address.zip;
        search_location.country = address.country;

        search_location.lat = response.results[0].geometry.location.lat;
        search_location.lng = response.results[0].geometry.location.lng;
        search_location.place_id = response.results[0].place_id;

        that.search_location = search_location;
      });
    },

    async getDashboardStats() {
      this.fetchingStats = true;
      let url = `${process.env.VUE_APP_API_ENDPOINT}/inbox/get-dashboard-stats`;

      let response = await axios.get(url, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.fetchingStats = false;

      this.dashboard_stats = response.data.stats;
    }
  },
  created() {
    this.$store.state.searches.fetchingSearches = true
    this.$store.dispatch('searches/fetch', {
      page: 1,
      itemsPerPage: 10
    })

    let self = this;
    this.searches_interval = setInterval(function() {
      self.$store.dispatch('searches/fetch', {
        page: 1,
        itemsPerPage: 10
      })
      self.getSearches();
    }, 5000);

    self.getSearches();

    self.getDashboardStats();
  },
  beforeDestroy() {
    clearInterval(this.searches_interval);
    this.searches_interval = null
  },
  watch: {
    locationSearchText (newVal) {
      var that = this;

      // If less than 3 chars typed, do not search
      if (!newVal || newVal.length <= 3) return

      // Call the method from the previous section here
      GetSuggestions(newVal)
        .then(function (res) {
          that.locationEntries = res;
        })
        .catch(function () {
          that.business = false;
          that.step = 1;
        })
    }
  }
}
</script>